module.exports = __webpack_public_path__ + "static/media/onboarding-2.0dfbc1a7.png";